<!-- 外层铜厚 -->
<template>
  <BaseFormItem
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
  </BaseFormItem>
</template>

<script>
import { getCEM1Fields } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'

export default {
  props: {
    value: {
      type: [String, Number],
      default: 1
    },
    // 产品类别
    board_type: {
      type: String,
      default: 'CEM-1'
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: +this.value
    }
  },
  computed: {
    fields() {
      return getCEM1Fields('copper')
    },
    options() {
      const { board_type, fields } = this
      const cem3Options = [{ value: 0.5, label: '0.5oz' }]

      return board_type === 'CEM-3' ? cem3Options : fields.options
    }
  },
  watch: {
    value(newVal) {
      this.val = +newVal
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      alertFieldsTips(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>